<template>
  <span
    class="tsny_resource-link"
    @click="downloadResource(resource.name, resource._id)"
    >{{ resource.name }}</span
  >
</template>

<script>
import CourseRestService from "../../services/rest/services/CourseRestService";

export default {
  name: "CourseResource",
  props: {
    resource: {
      type: Object,
      default: null
    }
  },
  methods: {
    downloadResource: function(resourceName, resourceId) {
      return CourseRestService.getResource(resourceId)
        .then(response => {
          let blob = new Blob([new Uint8Array(response.data)]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", resourceName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped></style>
